import { gql } from '@apollo/client';
import { PAGE_MAX } from '@oberoninternal/travelbase-website/dist/components/designsystem/Pagination';
import Companies, { BaseProps } from '@oberoninternal/travelbase-website/dist/components/pages/Companies';
import { addApolloState } from '@oberoninternal/travelbase-website/dist/createApolloClient';
import { GetStaticProps } from 'next';
import Seo from '../../components/Seo';
import { DEFAULT_REVALIDATION_TIME } from '../../constants/revalidationTime';
import { AgendaQuery, AgendaQueryVariables, CompanyDocument, CompaniesFragment } from '../../generated/graphql';
import initApolloClient, { PreviewData } from '../../initApolloClient';
import addGlobalQuery from '../../utils/addGlobalQuery';

export const query = gql`
    query Company($lang: String) {
        entry(section: ["companies"], site: [$lang]) {
            ...Companies
        }
    }

    fragment Companies on companies_Entry {
        settingsSeoTitle
        settingsMetaDescription
        localized {
            url
            language
        }
        title
    }
`;
interface Props extends BaseProps {
    entry: CompaniesFragment;
}

const Index = (props: Props) => {
    const { entry } = props;
    return (
        <>
            <Seo
                settingsMetaDescription={props.entry.settingsMetaDescription ?? ''}
                settingsSeoTitle={entry.settingsSeoTitle ?? entry.title ?? ''}
                alternates={entry.localized}
            />
            <Companies
                {...props}
                contentWrapperVariant="searchList"
                amountPerPage={PAGE_MAX}
                buttonTypes={['filters']}
            />
        </>
    );
};

export default Index;

export const getStaticProps: GetStaticProps = async context => {
    const { previewData } = context;
    const client = initApolloClient(context.locale as string, { previewData: previewData as PreviewData });

    const { data } = await client.query<AgendaQuery, AgendaQueryVariables>({
        query: CompanyDocument,
        variables: {
            lang: context.locale as string,
        },
    });

    const { entry } = data;

    return {
        ...addApolloState(
            client,
            (await addGlobalQuery(
                {
                    props: {
                        entry,
                    },
                },
                context.locale
            )) as { props: Record<string, unknown> }
        ),
        revalidate: DEFAULT_REVALIDATION_TIME,
    };
};
